import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { AzureCredentialsConfig } from './azure-credentials-config';
import { AzureCredentialsModalService } from './azure-credentials-modal.service';

@Component({
    selector: 'app-azure-credentials',
    templateUrl: './azure-credentials.component.html',
    styleUrl: './azure-credentials.component.scss',
    standalone: false
})
export class AzureCredentialsComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild("modalRef") modalComponent: ModalComponent;


  private readonly azureCredentialsModalService = inject(AzureCredentialsModalService);

  public configuration: AzureCredentialsConfig = new AzureCredentialsConfig();
  public entraUPN: string;
  public azureVirtualDesktopLink: string;

  constructor() {
  }

  ngOnInit(): void {
    this.entraUPN = this.configuration.entraUPN;
    this.azureVirtualDesktopLink = this.configuration.azureVirtualDesktopLink;
    this.azureCredentialsModalService.modalState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      if(!data) return;
      if (data?.config) {
        if (data?.isOpen) {
          this.open();
        }
        else {
          this.close();
        }
        this.configuration = data?.config;  
        this.entraUPN = this.configuration.entraUPN;
        this.azureVirtualDesktopLink = this.configuration.azureVirtualDesktopLink;
      }
    });
  }

  copyUPNToClipboard() {
    void navigator.clipboard.writeText(this.entraUPN);
  }
  open(): void {
    this.modalComponent?.open();
  }
  close(): void {
    this.modalComponent?.close();
  }
}
